import provider, { useStore, useSelector, useDispatch } from './store';

export { useStore, useSelector, useDispatch };
export default provider;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/store/index.js